export * as Queries from './queries';
// export * as Mutations from './mutations'; // No mutations to export. Uncomment this line when adding a mutation.
export * as Types from './types';
export * as Service from './service';

import { usePhoneNumbersV1QueryUpdaters } from './query-updaters';
/**
 * Query updaters should only be used internally by mutations in an api library that affects phone-numbers-v1 queries
 */
export const _QueryUpdaters = { useQueryUpdaters: usePhoneNumbersV1QueryUpdaters };
